import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import columns from './columns';

class PlayerMobile extends columns.Player {
  static displayName = 'ListMobile';

  static propTypes = {
    onTabSelect: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.ItemContainer = TabPanel;
    this.state = {
      scrolled: window.scrollY > 0,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY > 0) {
      this.setState({
        scrolled: true,
      });
    } else if (window.scrollY <= 0) {
      this.setState({
        scrolled: false,
      });
    }
  };

  /*
   * Renders component main element
   * */
  renderContainer(props) {
    const { children } = props;
    const { items } = this.props.item.content;

    return (
      <Tabs onSelect={this.props.onTabSelect}>
        <TabList
          className={`column__header ${this.state.scrolled ? 'scrolled' : ''}`}
        >
          {items.map((child, index) => (
            <Tab key={index}>
              {child.type === 'containers/pageset' ? 'Response' : 'Stimulus'}
            </Tab>
          ))}
        </TabList>
        {children}
      </Tabs>
    );
  }
}

export default {
  ...columns,
  Player: PlayerMobile,
};
